module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15Q7tPr/tc-custom/9781488018138.jpg?1702593802208",
      "alt": "This image is the cover for the book Falling for the Single Mom, Oaks Crossing"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Falling for the Single Mom, Oaks Crossing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Her Country Boy ")]), _c('br'), _c('br'), _vm._v("Big-city veterinarian Heather Fitzgerald didn't plan on having kidsuntil her niece is orphaned one tragic night. Soon she's trading in her ambitious life for a small-town animal rescue. Heather didn't expect to fall for tiny Oaks Crossingor its most charming bachelor farmer. But when Josh Kinley saves her niece from a near-tragic accident, he becomes more than her hero. Josh never thought he'd fall in love againand most assuredly not with another city woman. But he can't resist the two adorable Fitzgerald females. Now if Josh can only convince Heather to put down roots and make a home with him\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mia Ross\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Mia Ross loves great stories. She enjoys reading about fascinating people, long-ago times, and exotic places. But only for a little while, because her reality is pretty sweet. A lifelong resident of Upstate New York, she's married and the proud mom of 2 amazing kids whose schedules keep her hopping. Busy as she is, she can't imagine trading her life for anyone else's--and she has a pretty good imagination. You can visit her online at www.miaross.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0